import { connect } from 'react-redux';

import { selectors } from 'dux/user';
import ProfileCard from './ProfileCard';

const mapStateToProps = (state) => ({
  email: selectors.getIdentityState(state).email,
  role: selectors.getIdentityState(state).roles[0],
});

export default connect(mapStateToProps, null)(ProfileCard);
